import { render, staticRenderFns } from "./SupportModal.vue?vue&type=template&id=1a7ead80&scoped=true&"
import script from "./SupportModal.vue?vue&type=script&lang=js&"
export * from "./SupportModal.vue?vue&type=script&lang=js&"
import style0 from "./SupportModal.vue?vue&type=style&index=0&id=1a7ead80&scoped=true&lang=scss&"
import style1 from "./SupportModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7ead80",
  null
  
)

export default component.exports